<template>
    <svg class="o-ico" :class="class" aria-hidden="true" role="img">
        <use :xlink:href="this.$root.spriteURL+'#'+icon"></use>
    </svg>
</template>
<script>
    export default {
        name: 'svgIco',
        props: {
        	icon:{
        		type: String,
        		default: '',
            },
            class: {
                type: String,
                default: '',
            }
        },
    }
</script>